import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {SharedModule} from "./modules/shared/shared.module";
import {ActionReducer, MetaReducer, StoreModule} from "@ngrx/store";
import {localStorageSync} from "ngrx-store-localstorage";
import {EffectsModule} from "@ngrx/effects";
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {ApiInterceptor} from "./modules/shared/services/api.interceptor";
import {
  AuthenticationModule
} from "./modules/authentication/authentication.module";
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {
  BehaviorTrackerModule
} from "./modules/page-modules/behavior-tracker/behavior-tracker.module";
import {
  GroupsDashboardModule
} from "./modules/page-modules/group-dashboard/groups-dashboard.module";
import {
  GroupDetailsModule
} from "./modules/page-modules/group-details/group-details.module";
import {
  CoachGroupsListModule
} from "./modules/page-modules/coach-groups-list/coach-groups-list.module";
import {InviteModule} from "./modules/page-modules/invite/invite.module";
import {MetricsModule} from "./modules/page-modules/metrics/metrics.module";
import {
  ParticipantsListModule
} from "./modules/page-modules/participants-list/participants-list.module";
import {
  QuestionnaireModule
} from "./modules/page-modules/questionnaire/questionnaire.module";
import {
  SessionsListModule
} from "./modules/page-modules/sessions-list/sessions-list.module";
import {
  AdminGroupsListModule
} from "./modules/page-modules/admin-groups-list/admin-groups-list.module";
import {
  SuperAdminModule
} from "./modules/role-modules/super-admin/super-admin.module";
import {
  ClientsListModule
} from "./modules/page-modules/clients-list/clients-list.module";
import {
  ClientDetailsModule
} from "./modules/page-modules/client-details/client-details.module";

import {
  ResourcesHubModule
} from './modules/page-modules/resources-hub/resources-hub.module';
import {
  ManageUsersModule
} from "./modules/page-modules/manage-users/manage-users.module";
import {ProgressModule} from './modules/page-modules/progress/progress.module';
import {
  NotificationsModule
} from './modules/page-modules/notifications/notifications.module';
import {ReportsModule} from "./modules/page-modules/reports/reports.module";
import {ToastModule} from 'primeng/toast';
import {MessageService} from 'primeng/api';
import {
  ContractsModule
} from "./modules/page-modules/contracts/contracts.module";
import {
  MyJournalModule
} from './modules/page-modules/my-journal/my-journal.module';
import {
  FoodGuideManagementModule
} from './modules/page-modules/food-guide-management/food-guide-management.module';
import {
  ParticipantGroupsListModule
} from "./modules/page-modules/participant-groups-list/participant-groups-list.module";

export function sessionStorageSyncReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return localStorageSync({
    keys: [
      'ss-cord.shared',
      'ss-cord.authentication',
      'ss-cord.invite',
      'ss-cord.coach',
      'ss-cord.participant',
      'ss-cord.adult',
      'ss-cord.groups',
      'ss-cord.coach-groups-list',
      'ss-cord.client-admin-dashboard',
      'ss-cord.client-details',
      'ss-cord.participant-groups-list'
    ],
    rehydrate: true,
    storage: sessionStorage
  })(reducer);
}

const metaReducers: Array<MetaReducer<any, any>> = [sessionStorageSyncReducer];

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    BrowserAnimationsModule,
    StoreModule.forRoot({}, {metaReducers}),
    EffectsModule.forRoot([]),
    AuthenticationModule,
    NgxSkeletonLoaderModule.forRoot({animation: 'pulse'}),
    NgxMatSelectSearchModule,
    BehaviorTrackerModule,
    GroupsDashboardModule,
    GroupDetailsModule,
    CoachGroupsListModule,
    InviteModule,
    MetricsModule,
    ParticipantsListModule,
    ParticipantGroupsListModule,
    QuestionnaireModule,
    SessionsListModule,
    AdminGroupsListModule,
    SuperAdminModule,
    ClientsListModule,
    ClientDetailsModule,
    SessionsListModule,
    ResourcesHubModule,
    ManageUsersModule,
    ProgressModule,
    NotificationsModule,
    ReportsModule,
    ToastModule,
    ContractsModule,
    MyJournalModule,
    FoodGuideManagementModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true},
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

}
